import { useEffect, useState } from 'react'
import { Card, Col, Row, Modal, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux'

import styles from './index.module.css'


function ModalSlice({ open, setOpen, title, content }) {
    const handleOk = () => {
        setOpen(false);
    }

    return (
        <Modal
            open={open}
            title={title}
            onOk={handleOk}
            onCancel={handleOk}
            footer={false}
            className={styles.modal_slice}
        >
            <div className={styles.modal_content}>
                <div className={styles.content_title}>
                    切片内容
                </div>
                <div className={styles.content_box}>
                    {content}
                </div>
            </div>
        </Modal>
    )
}

function ComponentListContentSlice({setPageStatus, sliceList, setSliceList}) {
    const [open, setOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [content, setContent] = useState('')
    const [data, setData] = useState([])
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        setData(sliceList);
    }, [sliceList]);

    const handleClick = (t, c) => {
        setOpen(true)
        setTitle(t)
        setContent(c)
    }

    const handleSearch = () => {
        const filteredData = sliceList.filter((item) =>
            item.content.includes(searchText.trim())
        );
        setData(filteredData);
    }

    const handleChange = (e) => {
        let value = e.target.value
        setSearchText(e.target.value)
        console.log("value = ", value);

        console.log("filteredData = ", sliceList);
        const filteredData = sliceList.filter((item) =>
            item.content.includes(value.trim())
        )
        console.log("filteredData = ", filteredData);
        setData(filteredData)
    }

    const handleReback = () => {
        setSliceList([])
        setPageStatus('detail')
    }

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <Button
                    onClick={handleReback}
                >
                    返回组件详情页
                </Button>

                <Input.Search
                    placeholder="搜索切片内容"
                    value={searchText}
                    onSearch={handleSearch}
                    onChange={handleChange}
                    style={{ width: 200, marginBottom: 8 }}
                />
            </div>

            <Row gutter={16}>
                {
                    data && data.map((item, index) => {
                        let t = `${item.file_name} - 切片${index}`
                        return (
                            <Col span={8} style={{marginBottom: '20px'}} key={item.id}>
                                <Card
                                    type="inner"
                                    title={t}
                                    extra={
                                        <a onClick={() => { handleClick(t, item.content) }}>
                                            查看详情
                                        </a>
                                    }
                                >
                                    <div className={styles.slice_card_content}>
                                        { item.content }
                                    </div>
                                </Card>
                            </Col>
                        )
                    })
                }
            </Row>

            <ModalSlice
                open={open}
                setOpen={setOpen}
                title={title}
                content={content}
            />
        </div>
    )
}

export default ComponentListContentSlice